<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
  _/                                                                                                                    _/
  _/      子画面定義：ファイルインポート画面(STDSDC01C05)                                                               _/
  _/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isImportShow">
    <div class="popup" style="width: 650px">
      <div class="popup-head">インポート</div>
      <div class="popup-body blue">
        <!-- ****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage isModalError :errors="errors"></ErrorMessage>
        </p>
        <!-- -->
        <p>
          {{
            targetInfo
          }}をインポートします。インポートするファイルを選択してください。
        </p>
        <p class="sup-explanation" v-if="infoNameArea != ''">
          {{ infoNameArea }}
        </p>
        <p class="sup-explanation" v-if="infoNameAddArea != ''">
          {{ infoNameAddArea }}
        </p>
        <div
          class="frm-row"
          @dragenter="dragEnter"
          @dragleave="dragLeave"
          @dragover.prevent
          @drop.prevent="dropFile"
        >
          <div class="frm-file">
            <span class="frm-file-text">
              ここにファイルをドロップしてください。
              <br />または
            </span>
            <label class="frm-file-label">
              <input
                class="frm-file-item"
                tabindex="-1"
                type="file"
                accept=".xlsx, .csv"
                ref="file"
                @click="
                  (e) => {
                    e.target.value = '';
                  }
                "
                @change="selectedFile"
              />
              <span
                class="frm-btn"
                type="button"
                tabindex="0"
                ref="selectButton"
                @keydown.space.stop.prevent="$refs['file'].click()"
                >ファイルの選択</span
              >
            </label>
          </div>
        </div>
        <div class="frm-row" v-for="(file, index) in files" :key="index">
          <span class="frm-label w-140px">
            <strong v-if="index == 0">ファイル名</strong>
            <strong v-else></strong>
          </span>
          <span class="frm-label">{{ file.name }}</span>
        </div>
        <div class="frm-btn-row footer-btn">
          <div class="frm-item grow center">
            <button
              tabindex="0"
              class="frm-btn strong large"
              @click="importFile"
              :disabled="isDisabled"
            >
              インポート
            </button>
            <button tabindex="0" class="frm-btn large" @click="handleCancel">
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div></BaseModal
  >
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import ErrorMessage from "./ErrorMessage.vue";
import Common from "@/util/common.js";
import { API_DocumentManageUnlock } from "@/api/Modules/CM04/STDSCM04C00.js";
import { API_Import } from "@/api/Modules/DC01/STDSDC01C05.js";
import Validation from "@/util/validation.js";
import BaseModal from "@/components/Base/BaseModal.vue";

export default {
  name: "STDSDC01C05FileImportModal",
  components: {
    ErrorMessage,
    BaseModal,
  },
  props: {
    pageId: {
      type: String,
      required: true,
    },
    taxFilingDataId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isEnter: false,
      files: [],
      errors: [],
      targetInfo: "",
      infoNameArea: "",
      infoNameAddArea: "",
    };
  },
  created() {
    // 事業者情報の場合
    if (_.startsWith(this.pageId, "STDSDC02")) {
      this.targetInfo = "事業者情報";
      this.infoNameArea = "";
      this.infoNameAddArea = Common.getMessage("MTCL2028", [
        "事業者コード",
        "事業者情報",
      ]);
    } else if (_.startsWith(this.pageId, "STDSDC03")) {
      // 収集書類情報の場合
      this.targetInfo = "収集書類";
      this.infoNameArea = Common.getMessage("MTCL1054", []);
      this.infoNameAddArea = "";
    }
  },
  computed: {
    ...mapState("businessModule", ["importFlag"]),
    ...mapGetters("businessModule", ["isImportShow"]),
    // **********************************************
    // ボタン活性、非活性
    // **********************************************
    isDisabled() {
      return this.files.length == 0 ? true : false;
    },
  },
  watch: {
    importFlag: function (newVal) {
      if (newVal) {
        this.$nextTick(function () {
          this.initFocus();
        });
      }
    },
  },
  methods: {
    ...mapMutations("businessModule", ["importDialogue", "processDialogue"]),
    ...mapActions("businessModule", ["showProcessDialogue"]),

    // **********************************************
    // ファイルの選択
    // **********************************************
    selectedFile(e) {
      this.clearError();

      let files = e.target.files || e.dataTransfer.files;
      for (var i = 0, f; (f = files[i]); i++) {
        // ファイルのサイズをチェック
        if (Common.checkFileSize(f.size)) {
          this.errors.push(
            Common.createError("MTCL1053", Common.getMessage("MTCL1053"))
          );
          return;
        }
        // ファイル名にSJIS変換できない文字が含まれているかどうかのチェック
        if (
          Common.EscapeToSJIS(f.name) ||
          !Validation.checkNationalkinsokuchar(f.name)
        ) {
          this.errors.push(
            Common.createError(
              "MTCL1098",
              Common.getMessage("MTCL1098", ["ファイル名"])
            )
          );
          return;
        }
      }

      this.fileProcessing(files);
    },
    // **********************************************
    // 領域にドラッグが入った時に実行
    // **********************************************
    dragEnter() {
      this.isEnter = true;
    },
    // **********************************************
    // 領域からドラッグが出た時に実行
    // **********************************************
    dragLeave() {
      this.isEnter = false;
    },
    dragOver() {},
    // **********************************************
    // 領域でドラッグしているものをドロップしたら実行
    // **********************************************
    dropFile(e) {
      this.clearError();
      let files = e.dataTransfer.files;
      for (var i = 0, f; (f = files[i]); i++) {
        // iterate in the files dropped
        var entry = e.dataTransfer.items[i].webkitGetAsEntry();
        if (entry.isDirectory) {
          // The file is a folder
          this.errors.push(
            Common.createError("MTCL1106", Common.getMessage("MTCL1106", []))
          );
          return;
        }

        // ファイルのサイズをチェック
        if (Common.checkFileSize(f.size)) {
          this.errors.push(
            Common.createError("MTCL1053", Common.getMessage("MTCL1053"))
          );
          return;
        }
        // ファイル名にSJIS変換できない文字が含まれているかどうかのチェック
        if (
          Common.EscapeToSJIS(f.name) ||
          !Validation.checkNationalkinsokuchar(f.name)
        ) {
          this.errors.push(
            Common.createError(
              "MTCL1098",
              Common.getMessage("MTCL1098", ["ファイル名"])
            )
          );
          return;
        }
      }

      this.fileProcessing(files);

      this.isEnter = false;
    },
    // **********************************************
    // インポートファイル
    // **********************************************
    importFile() {
      let filesList = this.files;

      if (!filesList.length) return;

      let fileName = filesList[0].name.split(".");
      let suffix = fileName[fileName.length - 1];

      // 「'xlsx', 'csv'」以外場合
      if (!_.includes(["xlsx", "csv"], suffix)) {
        return;
      }

      let config = {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      };

      let formData = new FormData();
      for (let i = 0; i < filesList.length; i++) {
        formData.append("Files", filesList[i], filesList[i].name);
      }
      formData.append("PageID", this.pageId);
      formData.append("TaxFilingDataId", this.taxFilingDataId);

      this.processDialogue(true);

      // インポートボタン 非活性化
      this.isDisabled = true;
      // API呼出
      API_Import(formData, config) //←実装中なので、下記APIを例として挙げる
        .then((response) => {
          if (_.eq(response.result, "0000")) {
            // unlock
            // API呼出
            const param = {
              taxFilingDataId: this.taxFilingDataId,
            };
            API_DocumentManageUnlock(param).then((res) => {
              if (_.eq(res.result, "0000")) {
                // 初期化
                this.clearError();
                //主画面更新
                this.$emit("confirm", true);
                // 正常処理
                this.importDialogue(false);
                // 正常の場合
                // 「処理中」非表示 ＞「処理完了」表示
                this.showProcessDialogue(true);
              } else {
                // エラー初期化
                this.errors = [];

                this.errors.push(
                  Common.createError(
                    res.errorCD,
                    Common.getMessage(res.errorCD, res.errorName)
                  )
                );
              }
            });
          } else {
            // エラー初期化
            this.errors = [];

            // メッセージID
            const errorCode = response.errorCD;
            // 埋込み文字
            const errMsg = response.errorName;

            if (
              _.includes(
                [
                  "MTCL1001",
                  "MTCL1003",
                  "MTCL1004",
                  "MTCL1006",
                  "MTCL1007",
                  "MTCL1011",
                  "MTCL1034",
                  "MTCL1049",
                  "MTCL1098",
                  "MTCL1142",
                ],
                errorCode
              )
            ) {
              this.errors.push(
                Common.createError(
                  errorCode,
                  Common.getMessage(errorCode, [errMsg[0]])
                )
              );
            } else if (
              _.includes(
                ["MTCL1014", "MTCL1018", "MTCL1051", "MTCL1103"],
                errorCode
              )
            ) {
              this.errors.push(
                Common.createError(
                  errorCode,
                  Common.getMessage(errorCode, [errMsg[0], errMsg[1]])
                )
              );
            } else if (_.includes(["MTCL1010"], errorCode)) {
              this.errors.push(
                Common.createError(
                  errorCode,
                  Common.getMessage(errorCode, [
                    errMsg[0],
                    errMsg[1],
                    errMsg[2],
                  ])
                )
              );
            } else {
              this.errors.push(
                Common.createError(errorCode, Common.getMessage(errorCode, errMsg))
              );
            }
          }
          // 正常の場合
          // 「処理中」非表示 ＞「処理完了」表示
          this.processDialogue(false);

          // インポートボタン 活性化
          this.isDisabled = false;
        })
        .catch((error) => {
          console.log("error", error);
          // 異常の場合
          // 「処理中」非表示
          this.importDialogue(false);
          this.processDialogue(false);
          // 初期化
          this.clearError();

          // インポートボタン 活性化
          this.isDisabled = false;
        });
    },
    // **********************************************
    // キャンセルボタンをクリック
    // **********************************************
    handleCancel() {
      // unlock
      // API呼出
      const param = {
        taxFilingDataId: this.taxFilingDataId,
      };
      API_DocumentManageUnlock(param).then((response) => {
        if (_.eq(response.result, "0000")) {
          // 初期化
          this.clearError();
          this.importDialogue(false);
        } else {
          // エラー初期化
          this.errors = [];

          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
        }
      });
    },
    // **********************************************
    // エラーメッセージ、ファイルの初期化処理
    // **********************************************
    clearError() {
      this.files = [];
      this.errors = [];
    },
    // **********************************************
    // ファイル処理共通
    // **********************************************
    fileProcessing(file) {
      let fileName = file[0].name.split(".");
      let suffix = fileName[fileName.length - 1];

      // 「'xlsx', 'csv'」以外場合
      if (!_.includes(["xlsx", "csv"], suffix)) {
        this.files.push(file[0]);
        this.errors.push(
          Common.createError("MTCL1048", Common.getMessage("MTCL1048", []))
        );
        return;
      }

      if (_.isEmpty(this.files)) {
        this.files.push(file[0]);
      } else {
        const index = _.findIndex(this.files, (x) => {
          return _.eq(x.name, file[0].name);
        });
        // 結果が見つからなかったとき
        if (index < 0) {
          this.files.push(file[0]);
        }
      }
    },
    // **********************************************
    // 初期フォーカス設定
    // **********************************************
    initFocus() {
      this.$refs.selectButton.focus();
    },
  },
};
</script>
